import React, {PureComponent} from "react";
import {DialogManagerProps, IDailyBonusDialogOptions} from "../../../../../store/dialog-manager/types";
import styles from "./daily-bonus.module.css";
import dialogStyles from "../dialog.module.css";
import bonuses from "../../../../styles/bonuses.module.css";
import icons from "../../../../styles/icons.module.css";
import animations from "../../../../styles/animations.module.css";
import {cssHelper} from "../../../../utils/cssHelper";
import renderText from "../../../renderText";
import {Overlay} from "../../../overlay/Overlay";
import {toCssClassName} from "../../../../utils/toCssClassName";
import {BonusType, getBonusGroup} from "../../../../../store/player/types";
import {TimelineLite, Animation} from "gsap";
import playSound from "../../../../sounds/playSound";
import {shakeScale} from "../../../../utils/shake";
import i18n from "../../../../i18n";

export default class DailyBonusDialog extends PureComponent<IDailyBonusDialogOptions & DialogManagerProps> {
    private readonly hostElement: React.RefObject<HTMLDivElement>;
    private readonly activeTweens: Animation[] = [];


    constructor(props: IDailyBonusDialogOptions & DialogManagerProps, context: any) {
        super(props, context);

        this.hostElement = React.createRef();
    }

    render() {
        const dailyBonuses = this.renderDailyBonuses();

        return (
            <Overlay onClick={() => this.props.close()}>
                <button className={cssHelper(dialogStyles.close_button, icons.close).toString()} onClick={(e: React.MouseEvent) => this.close(e)}>✖</button>

                <div className={dialogStyles.container} ref={this.hostElement}>
                    {renderText(i18n("dailybonus.header"), 36, 80, 12, 20, styles.text)}
                    {renderText(i18n("dailybonus.details"), 26, 40, 32, 60, styles.text)}

                    <div className={styles.bonus_container}>
                        {dailyBonuses}
                    </div>

                    {renderText(i18n("dialog.taptocontinue"), 26, 32, 15, 30, cssHelper(styles.tap_to_continue, animations.blink).toString())}
                </div>
            </Overlay>
        );
    }

    componentDidMount(): void {
        const {animation} = this.props;

        if (!this.hostElement.current || !animation.enabled)
            return;

        const awarded = this.hostElement.current.getElementsByClassName(styles.bonus_awarded);

        const timeline = new TimelineLite()
            .staggerFrom(this.hostElement.current.childNodes, 0.33, {
                y: 50,
                opacity: 0
            }, 0.125)
            .staggerFrom(awarded, 0.33, {
                opacity: 1,
                onStart: () => playSound("daily-bonus-item-appear")
            }, 0.125);

        if (awarded.length > 0) {
            timeline
                .call(() => playSound("mouth-pop"))
                .add(shakeScale(awarded[awarded.length - 1], 0.5, 3, 0.1));
        }

        this.activeTweens.push(timeline);
    }

    componentWillUnmount(): void {
        for (let animation of this.activeTweens) {
            animation.kill();
        }
    }

    private renderDailyBonuses() {
        const {dailyStreak, dailyBonuses} =this.props;
        const currentStreak = Math.min(dailyStreak, dailyBonuses.length - 1);
        const itemHeader = i18n("dailybonus.itemheader").trim();

        return dailyBonuses.map((dailyBonus, day) => (
            <div key={day} className={cssHelper(styles.bonus).add(styles.bonus_awarded, currentStreak >= day).add(styles.bonus_current, currentStreak === day).toString()}>
                {renderText(itemHeader + " " + (day + 1), 20, 25, 5, 10, styles.bonus_day)}
                <div className={cssHelper(styles.bonus_icon, bonuses["bonus_icon_" + toCssClassName(BonusType[dailyBonus.bonus])]).toString()}>
                    <span className={styles.bonus_amount}>×{dailyBonus.amount}</span>
                </div>
                {renderText(i18n(`bonuses.${getBonusGroup(dailyBonus.bonus)}.${BonusType[dailyBonus.bonus].toLowerCase()}.uiname` as any), 12, 18, 10, 20, styles.bonus_caption)}
            </div>
        ))
    }

    private close(e: React.MouseEvent) {
        e.stopPropagation();
        this.props.close();
    }
}